export default "__VITE_ASSET__A1dbs5Wy__"